import { computed, onMounted, onUnmounted } from 'vue';

import { useUserStore } from '@/entities/user';
import { clearOutgoingMessagesQueue } from '@/features/message';
import { WebSocketClientController } from '@/shared/api';
import { ConnectionStatusController, type SharedUser, prepareSharedUser } from '@/shared/lib';

const useAuthenticatedLayout = () => {
  const userStore = useUserStore();
  const authenticatedUserID: string = userStore.user?.id ?? '';

  const sharedUser = computed<SharedUser>(() => {
    if (!userStore.user) {
      throw Error('Need authenticate when use AuthenticatedLayout');
    }

    return prepareSharedUser(userStore.user);
  });

  onMounted(() => {
    ConnectionStatusController.startMonitoring({ onOnline: WebSocketClientController.connect });
    WebSocketClientController.connect();
  });

  onUnmounted(() => {
    if (authenticatedUserID) {
      void clearOutgoingMessagesQueue(authenticatedUserID);
    }
    ConnectionStatusController.stopMonitoring();
    WebSocketClientController.close();
  });

  return { sharedUser };
};

export { useAuthenticatedLayout };
